import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Modal } from '@repo/design-system/components/ui/modal';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import type React from 'react';
interface PreferencesConflictModalProps {
  isOpen: boolean;
  onUseLinkFilters: () => void;
  onKeepMyFilters: () => void;
}
export const PreferencesConflictModal: React.FC<PreferencesConflictModalProps> = t0 => {
  const $ = _c(31);
  const {
    isOpen,
    onUseLinkFilters,
    onKeepMyFilters
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css.raw({
      padding: "16"
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Type variant="header-l" color="white">{t3}</Type>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp2);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Type variant="body-m" color="gray.200">{t5}</Type>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp3);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onUseLinkFilters || $[13] !== t7) {
    t8 = <Button onClick={onUseLinkFilters} color="white" size="lg">{t7}</Button>;
    $[12] = onUseLinkFilters;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t(_temp4);
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== onKeepMyFilters || $[18] !== t9) {
    t10 = <Button onClick={onKeepMyFilters} color="secondary" size="lg">{t9}</Button>;
    $[17] = onKeepMyFilters;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8) {
    t11 = <FlexRow gap="8">{t8}{t10}</FlexRow>;
    $[20] = t10;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t4 || $[25] !== t6) {
    t12 = <FlexColumn gap="16" className={t2}>{t4}{t6}{t11}</FlexColumn>;
    $[23] = t11;
    $[24] = t4;
    $[25] = t6;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== isOpen || $[28] !== onKeepMyFilters || $[29] !== t12) {
    t13 = <Modal isOpen={isOpen} onOpenChange={onKeepMyFilters} size="sm">{t12}</Modal>;
    $[27] = isOpen;
    $[28] = onKeepMyFilters;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
function _temp($) {
  return $.preferences_conflict_modal.title;
}
function _temp2($_0) {
  return $_0.preferences_conflict_modal.description;
}
function _temp3($_1) {
  return $_1.preferences_conflict_modal.use_link_filters;
}
function _temp4($_2) {
  return $_2.preferences_conflict_modal.keep_my_filters;
}